import React, { PureComponent } from 'react';
import { ISession } from 'types';
// Components
import { Map } from 'components/map';

interface SessionMapProps {
  session: ISession;
  range: [number, number];
  selectedIndexes: number[];
}
export default class SessionMap extends PureComponent<SessionMapProps> {
  render() {
    const { range, session, timestamp, selectedIndexes } = this.props;
    if (!session.gps) return false;
    return (
      <Map {...session.gps} timestamp={timestamp} range={range} selectedIndexes={selectedIndexes} />
    );
  }
}
